import React, { useState } from "react";
import "../../Styles/ThallikiVandanamForm.css";

const AdminThallikiVandanamForm = () => {
  const [formData, setFormData] = useState({
    motherName: "",
    relation: "",
    voterId:"",
    studentName: "",
    schoolName: "",
    className: "",
    aadhaar: "",
    mobile: "",
    bankAccount: "",
    ifsc: "",
    amount: "15000",
    village: "",
    mandal: "",
    date: "",
    status: "",
    remarks: "",
    photo: null,
    document: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className="thalliki-form-container">
      <div className="thalliki-form-card">
        <div className="thalliki-form-header">
          <h2>Add New Thalliki Vandanam Beneficiary</h2>
          <p>₹15,000 annual assistance to mothers for their school-going children's education</p>
          <button
            className="thalliki-back-btn"
            onClick={() => window.history.back()}
          >
            Back
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="thalliki-form-grid">

            <div className="thalliki-form-group">
              <label>Mother's Name *</label>
              <input
                type="text"
                name="motherName"
                placeholder="Enter Mother's Name"
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>Relation *</label>
              <input
                type="text"
                name="relation"
                placeholder="Ex: W/O, D/O"
                onChange={handleChange}
              />
            </div>
             <div className="thalliki-form-group">
              <label>VoterId  *</label>
              <input
                type="text"
                name="voterId"
                placeholder="Enter Voter Id"
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>Student Name *</label>
              <input
                type="text"
                name="studentName"
                placeholder="Enter Student Name"
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>School Name *</label>
              <input
                type="text"
                name="schoolName"
                placeholder="Enter School Name"
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>Class / Grade *</label>
              <input
                type="text"
                name="className"
                placeholder="Ex: 5th Class"
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>Aadhaar Number *</label>
              <input
                type="text"
                name="aadhaar"
                placeholder="Enter 12-digit Aadhaar Number"
                maxLength="12"
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>Mobile Number *</label>
              <input
                type="tel"
                name="mobile"
                placeholder="Enter Mobile Number"
                maxLength="10"
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>Bank Account Number *</label>
              <input
                type="text"
                name="bankAccount"
                placeholder="Enter Bank Account Number"
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>IFSC Code *</label>
              <input
                type="text"
                name="ifsc"
                placeholder="Enter IFSC Code"
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>Annual Amount (₹) *</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                readOnly
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>Village *</label>
              <input
                type="text"
                name="village"
                placeholder="Enter Village"
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>Mandal *</label>
              <select name="mandal" onChange={handleChange}>
                <option>Select Mandal</option>
                <option>Kandukur</option>
                <option>Gudluru</option>
                <option>Ulavapadu</option>
              </select>
            </div>

            <div className="thalliki-form-group">
              <label>Date *</label>
              <input
                type="date"
                name="date"
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>Status *</label>
              <select name="status" onChange={handleChange}>
                <option>Select Status</option>
                <option>Approved</option>
                <option>Pending</option>
              </select>
            </div>

            <div className="thalliki-form-group">
              <label>Upload Photo *</label>
              <input
                type="file"
                name="photo"
                accept="image/*"
                onChange={handleChange}
              />
            </div>

            <div className="thalliki-form-group">
              <label>Upload Supporting Document</label>
              <input
                type="file"
                name="document"
                accept=".pdf,image/*"
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="thalliki-form-group thalliki-full-width">
            <label>Remarks</label>
            <textarea
              rows="4"
              name="remarks"
              placeholder="Enter Remarks"
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="thalliki-btn-group">
            <button type="submit" className="thalliki-submit-btn">
              Submit
            </button>
            <button type="reset" className="thalliki-reset-btn">
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminThallikiVandanamForm;